<template>
  <div class="expenseCategorySettings">
    <van-list
      class="list"
      v-model="loading"
      :finished="finished"
      :finished-text="$t.meta.noMore"
      :error.sync="error"
      :error-text="errorText"
      @load="getList"
    >
      <div class="list-container" v-for="(item, index) in tableData" :key="index">
        <div class="list-item">
          {{ $t.expenseCategorySettings.project }}：{{ item.text }}
        </div>
        <div class="list-item">
          {{ $t.expenseCategorySettings.name }}：
          <span v-if="item.Items1.length > 0">
            <van-tag
              v-for="(child, index) in item.Items1"
              :key="index"
              size="large"
              type="primary"
              closeable
              @close="dialogDeleteShow(child.ECId)"
              style="margin-top: 10px; margin-right: 10px; margin-bottom: 10px"
            >
              {{ child.text }}
            </van-tag>
          </span>
          <span v-else>{{ $t.meta.noData }}</span>
        </div>
        <div class="list-item">
          {{ $t.expenseCategorySettings.category }}：
          <span v-if="item.Items1.length > 0">
            <div class="tag-group" v-for="(parent, pIndex) in item.Items2" :key="pIndex">
              <div class="tag-group-title">{{ parent.ParentName }}</div>
              <van-tag
                v-for="(child, cIndex) in parent.List"
                :key="cIndex"
                size="medium"
                type="default"
                closeable
                @close="dialogDeleteShow(child.ECId)"
                style="margin-top: 10px; margin-right: 10px; margin-bottom: 10px"
                >{{ child.text }}</van-tag
              >
            </div>
          </span>
          <span v-else>{{ $t.meta.noData }}</span>
        </div>
        <div class="buttons">
          <van-button
            class="primary-btn"
            size="small"
            type="primary"
            @click="dialogShow(item)"
            >{{ $t.meta.editButton }}</van-button
          >

          <van-button
            class="danger-btn"
            size="small"
            type="primary"
            @click="dialogDeleteShow(item.ECId)"
          >
            {{ $t.meta.delete }}
          </van-button>
        </div>
      </div>
    </van-list>

    <van-dialog
      :title="
        dialogType == 'edit'
          ? $t.expenseCategorySettings.editTitle
          : $t.expenseCategorySettings.addTitle
      "
      width="90%"
      v-model="dialogVisible"
      @confirm="dialogConfirm"
      @cancel="dialogCancel"
      :confirm-button-text="$t.meta.confirm"
      :cancel-button-text="$t.meta.cancel"
      :show-cancel-button="true"
      :show-confirm-button="true"
    >
      <slot name="default">
        <div class="expenseCategorySettings-alert">
          <van-form label-width="120px">
            <van-field
              v-model="addForm.ParentName"
              :label="$t.expenseCategorySettings.parent"
              @click="pickerShow"
              :placeholder="$t.meta.select"
              clickable
              readonly
              v-if="addForm.IsShow"
            />

            <van-field
              v-model="addForm.CategoryName"
              :label="
                addForm.ParentId
                  ? $t.expenseCategorySettings.name
                  : $t.expenseCategorySettings.project
              "
              :placeholder="$t.meta.input"
              required
            />
          </van-form>
        </div>
      </slot>
    </van-dialog>

    <van-dialog
      :title="$t.meta.notice"
      width="90%"
      v-model="showDeleteDialog"
      @confirm="deleteExpenseCategory"
      @cancel="showDeleteDialog = false"
      :confirm-button-text="$t.meta.confirm"
      :cancel-button-text="$t.meta.cancel"
      :show-cancel-button="true"
      :show-confirm-button="true"
    >
      <div style="margin: 20px; text-align: center">
        {{ $t.meta.deleteConfirm }}
      </div>
    </van-dialog>

    <van-popup v-model="showPicker" position="bottom">
      <van-tree-select
        :items="options"
        :main-active-index.sync="activeIndex"
        @click-item="onClickTree"
      />
    </van-popup>

    <div class="tool-bar">
      <van-button type="info" block @click="dialogShow(null)">{{
        $t.expenseCategorySettings.addButton
      }}</van-button>
    </div>
  </div>
</template>

<script>
import { List, Form, Field, Button, Tag, TreeSelect, Popup } from "vant";

import Vue from "vue";
Vue.use(List).use(Form).use(Field).use(Button).use(Tag).use(TreeSelect).use(Popup);

export default {
  name: "expenseCategorySettings",
  data() {
    return {
      UserId: JSON.parse(localStorage.getItem("auth")).userInfo.UserId,
      CompanyId: JSON.parse(localStorage.getItem("auth")).userInfo.CompanyId,
      tableData: [],
      options: [],
      page: 0,
      pageSize: 10,
      loading: false,
      finished: false,
      error: false,
      errorText: "",
      //dialog
      activeIndex: 0,
      dialogType: "add",
      dialogVisible: false,
      addForm: {
        ParentId: "",
        ParentName: "",
        ECId: "",
        CategoryName: "",
        IsShow: false,
      },
      showPicker: false,
      //delete
      dialogDeleteId: "",
      showDeleteDialog: false,
    };
  },
  created() {},
  methods: {
    onClickTree(e) {
      this.addForm.ParentName = e.text;
      this.addForm.ParentId = e.ECId;
      this.showPicker = false;
    },
    dialogConfirm() {
      if (this.dialogType == "add") {
        this.addExpenseCategory();
      }
      if (this.dialogType == "edit") {
        this.editExpenseCategory();
      }
    },
    dialogCancel() {
      this.initData();
      this.dialogVisible = false;
    },
    dialogShow(item) {
      if (item) {
        this.dialogType = "edit";
        this.addForm.ParentId = item.ParentId ? item.ParentId : "";
        this.addForm.ECId = item.ECId;
        this.addForm.CategoryName = item.text;
        this.addForm.IsShow = false;
      } else {
        this.dialogType = "add";
        this.addForm.IsShow = true;
      }
      this.dialogVisible = true;
    },
    initList() {
      this.loading = true;
      this.finished = false;
      this.error = false;
      this.tableData = [];
    },
    initData() {
      this.addForm.ParentId = "";
      this.addForm.ParentName = "";
      this.addForm.ECId = "";
      this.addForm.CategoryName = "";
    },
    pickerShow() {
      this.showPicker = true;
    },
    addExpenseCategory() {
      this.$commonMethod.showLoading();
      var param = {
        CategoryName: this.addForm.CategoryName,
        ParentId: this.addForm.ParentId,
      };
      this.$api.systemManagement
        .addExpenseCategory(param)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: res.message,
            type: "success",
          });
          this.dialogVisible = false;
          this.initList();
          this.initData();
          this.getList();
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    editExpenseCategory() {
      this.$commonMethod.showLoading();
      var param = {
        ECId: this.addForm.ECId,
        CategoryName: this.addForm.CategoryName,
        ParentId: this.addForm.ParentId,
      };
      this.$api.systemManagement
        .editExpenseCategory(param)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: res.message,
            type: "success",
          });
          this.dialogVisible = false;
          this.initList();
          this.initData();
          this.getList();
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    dialogDeleteShow(id) {
      this.dialogDeleteId = id;
      this.showDeleteDialog = true;
    },
    deleteExpenseCategory() {
      this.$commonMethod.showLoading();
      var param = {
        ECId: this.dialogDeleteId,
      };
      this.$api.systemManagement
        .deleteExpenseCategory(param)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: res.message,
            type: "success",
          });
          this.initList();
          this.getList();
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    getList() {
      var param = {};
      this.$api.systemManagement
        .getExpenseCategoryList(param)
        .then((res) => {
          this.getOptions(res.data);
          this.loading = false;
          this.error = false;
          this.errorText = "";
          this.finished = true;
        })
        .catch((error) => {
          this.loading = false;
          this.error = true;
          this.errorText = error.message;
        });
    },
    getOptions(data) {
      var options = [
        {
          text: this.$t.expenseCategorySettings.project,
          level: 1,
          children: [],
        },
        {
          text: this.$t.expenseCategorySettings.name,
          level: 2,
          children: [],
        },
      ];
      var list = [];
      for (var i in data) {
        list.push({
          ECId: data[i].ECId,
          text: data[i].CategoryName,
          ParentId: data[i].ParentId,
          Items1: [],
          Items2: [],
        });
        var option1 = options.find((p) => p.level == 1);
        option1.children.push({
          ECId: data[i].ECId,
          text: data[i].CategoryName,
          ParentId: data[i].ParentId,
        });
        for (const c1 in data[i].ExpenseSubCategory) {
          var item1 = data[i].ExpenseSubCategory;
          if (item1[c1].ParentId == data[i].ECId) {
            var push1 = {
              ECId: item1[c1].ECId,
              text: item1[c1].CategoryName,
              ParentId: item1[c1].ParentId,
            };
            list[i].Items1.push(push1);

            var option2 = options.find((p) => p.level == 2);
            option2.children.push(push1);
            for (const c2 in item1[c1].ExpenseSubCategory) {
              var item2 = item1[c1].ExpenseSubCategory;
              var push2 = {
                ECId: item2[c2].ECId,
                text: item2[c2].CategoryName,
                ParentId: item2[c2].ParentId,
                ParentName: item1.find((o) => o.ECId == item2[c2].ParentId).CategoryName,
              };
              list[i].Items2.push(push2);
            }
          }
        }
        list[i].Items2 = this.sortClass(list[i].Items2, "ParentName");
      }
      this.options = options;
      this.tableData = list;
    },
    sortClass(array, key, resKey = "List") {
      if (!key) return array;
      var aMap = [];
      var aResult = [];
      for (var i = 0; i < array.length; i++) {
        var item = array[i];
        if (aMap.indexOf(item[key]) === -1) {
          var oItem = {};
          oItem[resKey] = [item];
          oItem[key] = item[key];
          aResult.push(oItem);
          aMap.push(item[key]);
        } else {
          var index = aMap.indexOf(item[key]);
          aResult[index][resKey].push(item);
        }
      }
      return aResult;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~assets/scss/var";
.expenseCategorySettings {
  ::v-deep .van-sidebar-item--select::before {
    background-color: #1890ff !important;
  }
  ::v-deep .van-tree-select__item {
    font-weight: normal !important;
  }
  .list {
    width: 100%;
    display: inline-block;
    .list-container {
      font-size: 12px;
      color: #333;
      padding: 10px;
      margin-top: 10px;
      box-shadow: 0px 1px 5px 1px rgba(0, 0, 0, 0.2);
      .list-item {
        margin-bottom: 10px;
        .tag-group {
          margin-top: 10px;
          .tag-group-title {
            color: #1890ff;
          }
        }
      }
      .buttons {
        text-align: right;
        .primary-btn {
          margin-top: 5px;
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-primary;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
        .default-btn {
          margin-top: 5px;
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-light-gray;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
        .search-btn {
          margin-top: 5px;
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-green;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
        .danger-btn {
          margin-top: 5px;
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-red;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
      }
    }
  }
  .expenseCategorySettings-alert {
    overflow: scroll;
    max-height: 100vw;
    margin-top: 20px;
    margin-bottom: 20px;
  }
  .tool-bar {
    box-sizing: border-box;
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    background-color: white;
    z-index: 100;
    justify-content: space-between;
    padding-bottom: env(safe-area-inset-bottom);
    .van-button {
      border-radius: 0px;
    }
  }
}
</style>
